import React, { useEffect, useState } from 'react';
import { SignIn } from './components/SignIn'; 
import { Spin } from 'antd';
import ResBar from './components/Researcher/ResearcherBar';
import { useLocation } from 'react-router-dom';
import { Registered } from './components/RegistrationSuccess';
import { ResetPassword } from './components/ResetPassword';
import StaffBar from './components/Staff/Staffbar';
import PressBar from './components/President/PresidentBar';
import CommitteeBar from './components/Committee/CommitteeBar';
import CommitteeHome from './components/Committee/CommitteeChecked';
import { Firstpage } from './components/Researcher/FirstPage';
import { SignInMock } from './components/SignInMock';
import { InsiderSignIn } from './components/SignInForStaff';

function App() {
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState<string | null>(null);
  const [role, setRole] = useState<string | null>(null);
  const [isMultiplePos, setIsMultiplePos] = useState(false);
  const [IsInsiderLogin, setIsInsiderLogin] = useState('');
  const location = useLocation();
  useEffect(() => {

    const pathParts = location.pathname.split('/');
    
    if (
      pathParts[1] === 'VU_HREC' &&
      pathParts[2] === 'RegisterConfirm' &&
      pathParts[3]
    ) {
      const registerToken = pathParts[3];

      // Save token and role
      sessionStorage.setItem('token', registerToken);
      sessionStorage.setItem('role', 'register');
    }

    if (
      pathParts[1] === 'VU_HREC' &&
      pathParts[2] === 'ResetPassword'
    ) {
      const resetToken = 'reset';
      sessionStorage.setItem('token', resetToken);
      sessionStorage.setItem('role', 'resetPass');
    }

    if (
      pathParts[1] === 'VU_HREC' &&
      !sessionStorage.getItem('user') &&
      pathParts.length==2&&
      !sessionStorage.getItem('InsiderLogin')
    ) {
      sessionStorage.clear();
    }
  }, [location.pathname]);

    // Check sessionStorage for user data after page load
    useEffect(() => {
      const storedToken = sessionStorage.getItem("token");
      const storedRole = sessionStorage.getItem("role");
      const multiplePos = sessionStorage.getItem("IsMultiplePos") === 'yes';
      const insiderLogin = sessionStorage.getItem("InsiderLogin")

      if (storedToken) {
        setToken(storedToken);
        setRole(storedRole);
        setIsMultiplePos(multiplePos);
      }
      
      if(insiderLogin){
        setIsInsiderLogin(insiderLogin)
      }
  
      setLoading(false); // Stop loading once the data is retrieved
    }, []);

    if (loading) {
      return <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh', // full height of the viewport
      }}>
        <Spin size="large" />
      </div>;
    }
  
    if (!token) {
      // return <SignIn />;
      if(IsInsiderLogin=='Yes'){
      return <InsiderSignIn />;
      }
      return <SignInMock />;
    }else{
      switch (role) {
        case 'president':
          return <PressBar />;
        case 'staff':
          return <StaffBar />;
        case 'committee':
          return <CommitteeHome />;
        case 'Opening':
          return <Firstpage/>
        case 'researcher':
          return <ResBar/>;
          case 'register':
          return <Registered/>;
        case 'resetPass':
          return <ResetPassword/>;
        default:
          return <ResBar/>;
      }
    }
  
    
  };

export default App;
